export enum MetricUpdateAction {
  UPDATE = 'update',
  DELETE = 'delete',
}